import React, { useEffect } from 'react';

const Admin = () => {
  const adminUrl = process.env.REACT_APP_API_URL?.replace('/api', '/backend/admin/login.php');

  useEffect(() => {
    // Redirect to PHP admin panel
    if (adminUrl) {
      window.location.href = adminUrl;
    }
  }, [adminUrl]);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ color: '#C4A456', marginBottom: '16px' }}>
          Przekierowywanie do panelu administracyjnego...
        </h2>
        <p style={{ color: '#ccc' }}>
          Jeśli przekierowanie nie nastąpi automatycznie,{' '}
          <a
            href={adminUrl}
            style={{ color: '#C4A456', textDecoration: 'none' }}
          >
            kliknij tutaj
          </a>
        </p>
      </div>
    </div>
  );
};

export default Admin;